module.exports = __webpack_public_path__ + "static/tunnel-towers-foundation-6e5a53866ee6802492fd91c3af353a26.png";